/* eslint-disable */
import { Field, useFormState } from "react-final-form";
import Select from "react-select";
import { useCustomerInvoiceDetails } from "./useQuote";
import DatePicker from "react-datepicker";

const FormComponent = ({ customers, isEdit }) => {
  const { values } = useFormState();
  // Get customer's invoices when customer is selected
  const { invoices: invoiceData } = useCustomerInvoiceDetails(
    values?.customer?.value,
    isEdit
  );
  // Use customer invoices if available, otherwise show empty state
  const invoiceOptions =
    invoiceData?.invoices?.length > 0
      ? invoiceData?.invoices.map((invoice) => ({
        value: invoice.id,
        label: invoice.invoice_number,
        data: invoice,
      }))
      : [];

  const formattedOptions = (options) =>
    options?.map((option) => ({
      value: option.id,
      label: option?.user?.full_name,
      data: option,
    }));

  return (
    <>
      <div className="input-block mb-3">
        <label>
          Customer Name <span className="text-danger">*</span>
        </label>
        <div className="col-md-12">
          <Field name="customer">
            {({ input }) => {
              // Find the customer object from id if input.value is an id
              let selectedOption = null;
              const options = formattedOptions(customers);
              if (typeof input.value === "string") {
                selectedOption =
                  options?.find((opt) => opt.value === input.value) || null;
              } else {
                selectedOption = input.value;
              }
              return (
                <Select
                  {...input}
                  value={selectedOption}
                  onChange={input.onChange}
                  options={options}
                  placeholder="Choose Customer"
                  required
                />
              );
            }}
          </Field>
        </div>
      </div>
      <div className="input-block mb-3">
        <label>
          Invoice:
        </label>
        <div className="col-md-12 mb-3">
          <Field name="invoice">
            {({ input }) => (
              <Select
                className="w-100"
                value={input.value}
                onChange={input.onChange}
                options={invoiceOptions}
                placeholder="Select Invoice"
              />
            )}
          </Field>
        </div>
      </div>
      <div className="col-md-12 mb-3"></div>
      <div className="input-block mb-3">
        <label>
          Payment Type: <span className="text-danger">*</span>
        </label>
        <Field name="payment_type">
          {({ input }) => (
            <Select
              className="w-100"
              value={input.value}
              onChange={input.onChange}
              options={[
                { value: "advance", label: "Advance Payment" },
                { value: "balance", label: "Balance Payment" },
              ]}
              placeholder="Select Payment Type"
              required
            />
          )}
        </Field>
      </div>
      <div className="col-md-12 mb-3">
        <div className="input-block mb-3">
          <label>
            Amount Received: <span className="text-danger">*</span>
          </label>
          <Field name="amount_received">
            {({ input }) => (
              <input
                {...input}
                type="text"
                className="form-control"
                placeholder="Enter amount received "
                required
              />
            )}
          </Field>
        </div>
      </div>
      <div className="col-md-12">
        <div className="input-block mb-3">
          <label>Payment Date:</label>
          <Field name="payment_date">
            {({ input }) => (
              <div className="cal-icon">
                <DatePicker
                  className="datetimepicker form-control"
                  selected={input.value}
                  onChange={input.onChange}
                  dateFormat="dd/MM/yyyy"
                  placeholderText="Select Payment Date"
                />
              </div>
            )}
          </Field>
        </div>
      </div>
      <div className="col-md-12">
        <div className="input-block mb-3">
          <label>Reference#</label>
          <Field name="reference_number">
            {({ input }) => (
              <input
                {...input}
                type="text"
                className="form-control"
                placeholder="Add reference"
              />
            )}
          </Field>
        </div>
      </div>

      <div className="col-md-12">
        <div className="input-block mb-3">
          <label>Attachment</label>
          <Field name="attachment">
            {({ input: { value, onChange, ...input } }) => (
              <div className="custom-file">
                <input
                  type="file"
                  className="form-control"
                  id="customFile"
                  onChange={(e) => {
                    onChange(e.target.files[0]);
                  }}
                  {...input}
                  value={undefined} // React doesn't support value on file inputs
                />
                <small className="form-text text-muted">
                  Upload payment receipt, bank statement, or related document
                  (Max size: 5MB)
                </small>
                {value && (
                  <div className="mt-2">
                    <span
                      className="text-success"
                      style={{ cursor: typeof value === 'string' ? 'pointer' : 'default' }}
                      onClick={() => {
                        if (typeof value === 'string') {
                          // If value is a URL string, download it
                          const link = document.createElement('a');
                          link.href = value;
                          link.download = value.split('/').pop() || 'attachment';
                          link.target = '_blank';
                          document.body.appendChild(link);
                          link.click();
                          document.body.removeChild(link);
                        }
                      }}
                    >
                      <i className="fa fa-check-circle"></i>{" "}
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        style={{ display: 'inline-block', verticalAlign: 'middle', marginRight: '4px' }}
                      >
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                        <polyline points="14 2 14 8 20 8"></polyline>
                        <line x1="16" y1="13" x2="8" y2="13"></line>
                        <line x1="16" y1="17" x2="8" y2="17"></line>
                        <polyline points="10 9 9 9 8 9"></polyline>
                      </svg>
                      {typeof value === 'string' ? value.split('/').pop() : value.name}
                      {typeof value === 'string' && (
                        <i className="fa fa-download ms-2" style={{ fontSize: '12px' }}></i>
                      )}
                    </span>
                  </div>
                )}
              </div>
            )}
          </Field>
        </div>
      </div>
      <div className="text-start mt-4">
        <button type="submit" className="btn btn-primary">
          Add Payments
        </button>
      </div>
    </>
  );
};

export default FormComponent;
